import { useSortable } from '@dnd-kit/sortable';
import { Disabled } from '@dnd-kit/sortable/dist/types';
import { CSS } from '@dnd-kit/utilities';
import React, { CSSProperties, ReactNode, useMemo } from 'react';

import { MenuEditorDragData } from './types';

export type DnDItemProps = {
  children: ((data: ReturnType<typeof useSortable>) => ReactNode) | ReactNode;
  className?: string;
  data: MenuEditorDragData;
  id: string;
  disabled?: Disabled | boolean;
  style?: CSSProperties;
};

const MenuEditorDnDItem = ({ className, id, style, children, data, disabled }: DnDItemProps) => {
  const sortable = useSortable({
    id,
    disabled,
    data,
  });

  const dndStyle: CSSProperties = useMemo(
    () => ({
      ...style,
      transform: CSS.Transform.toString(sortable.transform),
      transition: sortable.transition,
    }),
    [sortable.transform, sortable.transition, style],
  );

  return (
    <div
      className={className}
      style={dndStyle}
      ref={sortable.setNodeRef}
      {...sortable.attributes}
      {...sortable.listeners}
    >
      {typeof children === 'function' ? children(sortable) : children}
    </div>
  );
};

export default React.memo(MenuEditorDnDItem);
